import { render } from "./PersonalPrices.vue?vue&type=template&id=1c812d4c&scoped=true"
import script from "./PersonalPrices.vue?vue&type=script&lang=js"
export * from "./PersonalPrices.vue?vue&type=script&lang=js"

import "./PersonalPrices.vue?vue&type=style&index=0&id=1c812d4c&scoped=true&lang=scss"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c812d4c"]])

export default __exports__